module.exports = __webpack_public_path__ + "static/media/mode_click.82fec144.wav";